import styled from 'styled-components';

export default styled.div`
  width: 1240px;

  margin-left: auto;
  margin-right: auto;
  padding: 30px 15px;
`;
